<template>
  <div class="login-container">
    <div class="form-main-container">
      <div class="left-logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 351.43 63.58" role="img" focusable="false" aria-labelledby="header-logo-title">
          <title id="header-logo-title">Loreal</title>
          <polygon points="191.19 59.31 236.54 59.31 236.54 53.77 198.97 53.77 198.97 36.04 227.19 36.04 227.19 30.44 198.97 30.44 198.97 14.11 236.54 14.11 236.54 8.59 191.19 8.59 191.19 59.31" />
          <polygon points="214.76 0.39 208.62 7.29 227.89 0.39 214.76 0.39" />
          <polygon points="305.59 8.59 305.59 59.3 351.43 59.3 351.43 53.77 312.68 53.77 312.68 8.59 305.59 8.59" />
          <path d="M264.81,40.17,277,16l12.29,24.22ZM272,8.94,246.24,59.66H255l6.6-13.13h30.93l6.65,13.13h8.63L282,8.94Z"
                transform="translate(-6.1 -0.35)" />
          <path d="M166.61,32.39H142.92V14.94h24.51c5.64,0,8.82,2.63,10,6a9.45,9.45,0,0,1-1,7.36c-2,3.39-5.94,4.11-9.8,4.11m6.07,6.06c11.62-3.1,12.75-11.75,12.69-14.84-.69-9.06-6.8-14.67-17.77-14.67h-32V59.66h7.29V38.38h20.81L179,59.66h9.19s-11-14.32-15.55-21.21"
                transform="translate(-6.1 -0.35)" />
          <path d="M91.84.35c-20.57,0-34.59,14.5-34.59,32.06,0,18.48,15.49,31.53,34.59,31.53s34.57-12.86,34.57-31.53C126.41,14.85,112.22.35,91.84.35Zm-.25,57.29c-14.23,0-25.95-11.44-25.95-25.21S76.81,6.68,92.14,6.68a25.74,25.74,0,0,1,26,25.75C118.1,46.2,105.82,57.64,91.59,57.64Z"
                transform="translate(-6.1 -0.35)" />
          <polygon points="32.8 26.53 38.05 26.53 47.6 8.59 39.92 8.59 32.8 26.53" />
          <polygon points="0 8.59 0 59.3 45.84 59.3 45.84 53.77 7.09 53.77 7.09 8.59 0 8.59" />
        </svg>
      </div>
      <div class="login-form">
        <form>
          <div class="error-msg" v-show="showErrorMsg">
            <p>{{ errorMsg }}</p>
          </div>
          <div class="form-field">
            <span class="form-label" :class="{'active' : usernameLabel || userName !== ''}">{{ usernameLabel ? 'Username' : 'Enter your Username' }}</span>
            <input type="text" class="input-field" v-model="userName" @focus="usernameLabel = true" @blur="userName === '' ? usernameLabel = false: true" autocomplete="off" @keypress.enter="validateForm">
            <label>Please use your Sitecore Account</label>
          </div>
          <div class="form-field">
            <span class="form-label" :class="{'active' : passwordLabel || password !== ''}">{{ passwordLabel ? 'Password' : 'Enter your Password' }}</span>
            <input :type="showPassword ? 'text':'password'" class="input-field" v-model="password" @focus="passwordLabel = true" @blur="password === '' ? passwordLabel = false: true" autocomplete="off" @keypress.enter="validateForm">
            <span class="show-password" :class="{'password-hide': showPassword}" @click="showPassword = !showPassword"><img src="/-/media/Feature/NewBOPRNews/eye-open.png" alt="eye"></span>
            <label>Please use your Sitecore Password</label>
          </div>
          <div class="form-submit">
            <a href="mailto:sivashankar.selvaraj@photoninfotech.net" class="contact-support-btn">Contact support</a>
            <button type="button" class="login-btn" @click="validateForm" :disabled="this.userName === '' || this.password === ''">Login</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { fetchData } from '@Foundation/services';
  export default {
    name: 'bo-login',
    data() {
      return {
        userName: '',
        password: '',
        showErrorMsg: false,
        errorMsg: 'Please enter your login credentials.',
        usernameLabel: false,
        passwordLabel: false,
        showPassword: false,
        locationReload: false
      };
    },
    methods: {
      validateForm() {
        if (this.userName === '' || this.password === '') {
          this.showErrorMsg = true;
        } else {
          this.showErrorMsg = false;
          fetchData(`/NewBoPrNews/UserLogin?UserName=${this.userName}&Password=${this.password}`).then(response => {
            if (response.isvalidcreds === true) {
              window.location.href = response.responseurl;
            } else {
              this.showErrorMsg = true;
              this.errorMsg = response.errormessage;
            }
          });
        }
      }
    }
  };
</script>
<style lang="scss" src="./bo-login.scss"></style>
